import { motion, AnimatePresence } from "framer-motion";
import { useMediaQuery } from "@mui/material";



import MailIcon from "@mui/icons-material/Mail";
import CallIcon from "@mui/icons-material/Call";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Footer from "../components/Layout/Footer";
import Header from "../components/Layout/Header";

import React, { useEffect, useRef,useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";




const Contact = () => {
  const contactRef = useRef(null);
  const [showNewBoxes, setShowNewBoxes] = useState(false);
  const isMobile = useMediaQuery("(max-width:780px)");
 // const [showNewBoxes, setShowNewBoxes] = useState(false);
  const [resetSize, setResetSize] = useState(false);
  const arrowRef = useRef(null);
  const hexagonRefs = useRef([]);
  


 




  useEffect(() => {
  if (isMobile) return; // ✅ Skip ResizeObserver for mobile view

  const checkOverlap = () => {
    if (!arrowRef.current || hexagonRefs.current.length === 0) return;
    const arrowRect = arrowRef.current.getBoundingClientRect();
    const isOverlapping = hexagonRefs.current.some((hexagon) => {
      if (!hexagon) return false;
      const hexagonRect = hexagon.getBoundingClientRect();
      return (
        arrowRect.bottom > hexagonRect.top ||
        arrowRect.right > hexagonRect.left
      );
    });
    setResetSize(isOverlapping);
  };

  const observer = new ResizeObserver(checkOverlap);
  if (arrowRef.current) observer.observe(arrowRef.current);
  hexagonRefs.current.forEach((hex) => hex && observer.observe(hex));

  window.addEventListener("resize", checkOverlap);
  checkOverlap();

  return () => {
    observer.disconnect();
    window.removeEventListener("resize", checkOverlap);
  };
}, [isMobile]);


    

  const arrowStyleRed = {
    background: "linear-gradient(to bottom, #5D0A0B, #3D0708)",
    color: "white",
    clipPath: "polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0 100%)",
    cursor: "pointer",
    fontSize: resetSize ? "22px" : "clamp(14px, 2vw, 30px)",
    width: resetSize ? "250px" : "clamp(250px, 40vw, 550px)",
    height: resetSize ? "100px" : "clamp(100px, 15vh, 200px)",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    lineHeight: "1.2",
    overflow: "visible",
    fontFamily: "Teko",
    position: "absolute",
  
    /** 🛠 FIXED: Clamp left so it doesn't overflow on zoom */
    left: "clamp(-8vw, -4vw, 0vw)",
  
    zIndex: 10,
    padding: "clamp(20px, 3.5vw, 50px)",
    minWidth: "340px",
    minHeight: "140px",
  
    boxShadow: `
      0px 12px 25px rgba(0, 0, 0, 0.6),
      inset 0px 10px 20px rgba(255, 255, 255, 0.15),
      inset 0px -10px 30px rgba(0, 0, 0, 0.7),
      inset 10px 0px 20px rgba(0, 0, 0, 0.5),
      inset -10px 0px 20px rgba(255, 255, 255, 0.2),
      inset 15px 15px 20px rgba(0, 0, 0, 0.6),
      inset -15px -15px 20px rgba(255, 255, 255, 0.2)
    `,
  
    borderBottom: "6px solid rgba(0, 0, 0, 0.7)",
    borderLeft: "6px solid rgba(0, 0, 0, 0.5)",
    borderRight: "6px solid rgba(255, 255, 255, 0.2)",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
  };
  

  const arrowStyleGold = {
    ...arrowStyleRed,
    background: "linear-gradient(to bottom, #FFD700, #B8860B)",
    color: "black",
  };

  const hexagonStyle = {
    display: "flex",
    minWidth: "250px", 
    minHeight: "220px", 
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    width: resetSize ? "200px" : "clamp(150px, 25vw, 280px)",
    height: resetSize ? "180px" : "clamp(130px, 23vw, 250px)",
    padding: "clamp(10px, 2vw, 20px)",
    fontSize: "clamp(10px, 2vw, 14px)",
    color: "#fff",
    backgroundColor: showNewBoxes ? "gold" : "#5D0A0B",
    clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
    flexShrink: 0,
    transition: "all 0.3s ease-in-out",
  
     /** ✅ 6-Sided Depth & Shadows **/
     boxShadow: `
     0px 12px 25px rgba(0, 0, 0, 0.6),  /* Outer shadow */
     inset 0px 10px 20px rgba(255, 255, 255, 0.15), /* Soft top light */
     inset 0px -10px 30px rgba(0, 0, 0, 0.7), /* Bottom shadow */
     inset 10px 0px 20px rgba(0, 0, 0, 0.5), /* Left shadow */
     inset -10px 0px 20px rgba(255, 255, 255, 0.2), /* Right highlight */
 
     /** 🌟 Side Shadows for Full 3D Depth **/
     inset 15px 15px 20px rgba(0, 0, 0, 0.6), /* Bottom-left */
     inset -15px -15px 20px rgba(255, 255, 255, 0.2) /* Top-right */
   `,
 
   /** ✅ 3D Borders (No Top Border) **/
   borderBottom: "6px solid rgba(0, 0, 0, 0.7)",  
   borderLeft: "6px solid rgba(0, 0, 0, 0.5)",  
   borderRight: "6px solid rgba(255, 255, 255, 0.2)",  
   borderBottomLeftRadius: "10px",  
   borderBottomRightRadius: "10px",  
  };
  



  useEffect(() => {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);
  
  const getBoxes = (showNewBoxes) =>
    showNewBoxes
      ? [
          { title: "Full Training", content: "Get all the knowledge you need about our chai blends, café operations, and customer service." },
          { title: "Operational Support", content: "Ongoing guidance in day-to-day operations, marketing strategies, and inventory management." },
          { title: "Exclusive Territories", content: "We offer prime locations and exclusive territorial rights for your franchise." },
          { title: "Marketing & Branding", content: "Access our professional marketing campaigns, branding materials, and social media support." },
          { title: "Quality Ingredients & Supplies", content: "We provide the best ingredients and resources to maintain our high-quality chai." },
        ]
      : [
          { title: "Proven Concept", content: "Our café has built a loyal customer base with unique offerings and cozy ambiance." },
          { title: "Comprehensive Support", content: "From training to marketing, we guide you at every step to help your business succeed." },
          { title: "Flexible Investment Options", content: "We offer various franchise packages to fit your budget and goals." },
          { title: "Community Focus", content: "Our cafes foster a sense of community, making a positive impact in local neighborhoods." },
          { title: "Established Brand", content: "Join a brand with a strong presence in the chai café industry and a reputation for quality." },
        ];

      
        
        const boxes = getBoxes(showNewBoxes);
  

  

 
  
  // Animation for Arrows
  const arrowAnimation = (index) => ({
    initial: { opacity: 0, x: -50 }, // Start off-screen
    animate: { 
      opacity: 1, 
      x: 0, 
      transition: { delay: index * 0.5, duration: 0.8, ease: "easeOut" } 
    }
  });
  
const handleButtonClick = (showNew) => {
  setShowNewBoxes(showNew);
}


  

  return (
    <>
      <Header />
{/* Mobile View (Hexagon Style) */}
  {isMobile ? (
   <Box
   sx={{
     backgroundImage: "url('/image/contactimg.jpg')", // Change path as needed
     backgroundSize: "cover",
     backgroundPosition: "center",
     minHeight: "100vh",
     display: "flex",
     flexDirection: "column",
     alignItems: "center",
     
     py: 5,
     justifyContent: "flex-start", // Moves everything up
     paddingTop: "100px", // Reduced padding to bring content higher
   }}
 >
   {/* Franchise Heading */}
   <Typography
     variant="h2"
     sx={{
       fontFamily: "Teko",
       color: "white",
       fontSize: { xs: "2rem", md: "2.5rem" },
       textTransform: "uppercase",
       mb: 3,
       textAlign: "center",
       letterSpacing: "2px",
       fontWeight: "bold",
       
     }}
   >
     Franchise
   </Typography>

   {/* Franchise Buttons */}
   <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", mb: 5 , paddingTop: "40px",}}>
     <motion.button
       style={{
        ...buttonStyle,
        backgroundColor: "#5D0A0B", // Updated color
      }}
       onClick={() => handleButtonClick(false)}
       whileHover={{ scale: 1.1 }}
       whileTap={{ scale: 0.9 }}
     >
       Why Choose Kadak Cafe Franchise?
     </motion.button>
     <motion.button
        style={{
          ...buttonStyle,
          color:"black", 
          fontWeight:"bold",
        }}
       onClick={() => handleButtonClick(true)}
       whileHover={{ scale: 1.1 }}
       whileTap={{ scale: 0.9 }}
     >
       What We Offer Our Franchise Partners
     </motion.button>
   </Box>

   {/* Continuous Horizontal Scrolling Banner */}
   <Box
     sx={{
       width: "100%",
       position: "relative",
       overflowX: "hidden",
       display: "flex",
       justifyContent: "center",
       paddingTop: "30px",
     }}
   >
     <Box
       sx={{
         display: "flex",
         animation: `scrollBoxes 15s linear infinite`,
         gap: "20px",
       }}
     >
       <AnimatePresence>
         {[...getBoxes(showNewBoxes), ...getBoxes(showNewBoxes)].map((box, index) => (
           <motion.div
             key={index}
             style={{
               ...hexagonStyle1,
               backgroundColor: showNewBoxes ?"gold" : "#5D0A0B", 
               color: showNewBoxes ? "black" : "white",
             }}
             animate={{
               opacity: 1,
               x: 0,
               transition: { delay: index * 0.15, duration: 0.7, ease: "easeInOut" },
             }}
             initial={{ opacity: 0, x: -100 }}
             exit={{ opacity: 0, x: 100, transition: { duration: 0.4 } }}
           >
             <div
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                textAlign: "center",
                fontFamily:"Teko",
                color: showNewBoxes ? "black" : "white", // Ensure heading color changes too
              }}
            >{box.title}</div>
             <div
style={{
  fontSize: "16px",
  textAlign: "center",
  padding: "5px",
  fontFamily: "Roboto, sans-serif", // ✅ Kept Roboto for content
}}
>
{box.content}
</div></motion.div>
         ))}
       </AnimatePresence>
     </Box>
   </Box>
 </Box>

  ) : (
    // Desktop View (Structured Style)
      
<Box
  ref={contactRef}
  sx={{
    backgroundImage: "url('/image/contactimg.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    py: "10vh", // Increased padding to move content down
    mt: "5vh", // Adjusted top margin for additional spacing
    mb: "5vh",
    overflow: "visible", // Ensure children are not clipped
    position: "relative", // Required for absolute positioning of children
  }}
>

 
     {/* 🔴 Red Arrow fixed left but still animated */}
     <motion.div
  ref={arrowRef}
  style={{
    ...arrowStyleRed,
    position: "absolute", // Keep position as absolute
    left: "0vw", // Maintain original positioning
    zIndex: 10,
    top: "38vh", // Adjust based on third row placement
    pointerEvents: "auto", // Ensure interaction works properly
  }}
  {...arrowAnimation(0)}
  whileHover={{ scale: 1.1 }}
  whileTap={{ scale: 0.9 }}
  onClick={() => setShowNewBoxes(false)}
>
  Why Choose Kadak Cafe Franchise?
</motion.div>




   <AnimatePresence mode="wait">
  <motion.div
    key={showNewBoxes ? "new" : "original"}
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -50 }}
    transition={{ duration: 0.5 }}
    style={{ display: "flex", flexDirection: "column", gap: "5vh" }}
  >
    {/* First Row with Red Arrow at Left */}
    <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "clamp(4vw, 6vw, 8vw)",
    padding: "0 5vw",
    flexWrap: "wrap",
    position: "relative",
  }}
>
     

      {/* First 2 Hexagon Boxes */}
      <div
        style={{
          display: "flex",
          gap: "clamp(4vw, 6vw, 8vw)",
          flexWrap: "wrap",
        //  marginLeft: "clamp(20vw, 22vw, 24vw)", // keep spacing from left
        marginLeft: "clamp(28vw, 30vw, 32vw)", // keep boxes positioned
        }}
      >
        {[boxes[0], boxes[1]].map((box, index) => (
          <motion.div
            key={`hexagon-${index}`}
            style={{
              ...hexagonStyle,
              backgroundColor: showNewBoxes ? "gold" : "#5D0A0B",
              color: showNewBoxes ? "black" : "white",
            }}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <div style={hexagonTextStyle}>{box.title}</div>
            <div style={hexagonContentStyle}>{box.content}</div>
          </motion.div>
        ))}
      </div>
    </div>
  </motion.div>
</AnimatePresence>




      {/* -------- Center Hexagon -------- */}
      <AnimatePresence mode="wait">
  <motion.div
    key={showNewBoxes ? "new" : "original"}
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -50 }}
    transition={{ duration: 0.5 }}
    style={{ display: "flex", flexDirection: "column", gap: "5vh" }}
  >
      <div
        style={{
          transform: "translateX(15vw)",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <motion.div
          key={`hexagon-center`}
          style={{
            ...hexagonStyle,
            backgroundColor: showNewBoxes ? "gold" : "#5D0A0B",
            color: showNewBoxes ? "black" : "white",
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -30 }}
          transition={{ duration: 0.4, delay: 0.3 }}
        >
          <div style={hexagonTextStyle}>{boxes[2].title}</div>
          <div style={hexagonContentStyle}>{boxes[2].content}</div>
        </motion.div>
      </div>
      </motion.div>
</AnimatePresence>

      


     {/* -------- First Row with Red Arrow on Left Margin -------- */}

 {/* 🟡 Gold Arrow Fixed to Absolute Left Margin */}
 <motion.div
  style={{
    ...arrowStyleGold,
    position: "absolute", // Keep position as absolute
    left: "0vw", // Maintain original positioning
    zIndex: 10,
    top: "68vh", // Adjust based on third row placement
    pointerEvents: "auto", // Ensure interaction works properly
  }}
  {...arrowAnimation(0)}
  whileHover={{ scale: 1.1 }}
  whileTap={{ scale: 0.9 }}
  onClick={() => setShowNewBoxes(true)}
>
  What We Offer Our Franchise Partners
</motion.div>


  {/* First row hexagon boxes */}
  <AnimatePresence mode="wait">
  <motion.div
    key={showNewBoxes ? "new" : "original"}
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -50 }}
    transition={{ duration: 0.5 }}
    style={{ display: "flex", flexDirection: "column", gap: "5vh" }}
  >
  <div
    style={{
      display: "flex",
      gap: "clamp(4vw, 6vw, 8vw)",
      flexWrap: "wrap",
      marginLeft: "clamp(28vw, 30vw, 32vw)", // keep boxes positioned
    }}
  >
    {[boxes[0], boxes[1]].map((box, index) => (
      <motion.div
        key={`hexagon-${index}`}
        style={{
          ...hexagonStyle,
          backgroundColor: showNewBoxes ? "gold" : "#5D0A0B",
          color: showNewBoxes ? "black" : "white",
        }}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -30 }}
        transition={{ duration: 0.4, delay: index * 0.1 }}
      >
        <div style={hexagonTextStyle}>{box.title}</div>
        <div style={hexagonContentStyle}>{box.content}</div>
      </motion.div>
    ))}
  </div>
  </motion.div>
  </AnimatePresence>




 
</Box>





  






        
  )}
  
    
        <br></br><br></br>
    


      {/* Contact Details and Our Location */}
      <Box
sx={{
  display: "flex",
  justifyContent: "space-between", // Ensures spacing between both sections
  alignItems: "center", // Vertically aligns text & underlines
  width: "100%",
  px: { xs: "5%", md: "1in" },
  mb: 2,
  flexWrap: "wrap", // Ensures responsiveness
}}
>
  {/* Left Side: Contact Details */}
  <Box
  sx={{
    flex: 1,
    minWidth: "300px",
    maxWidth: "500px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "none",  // Removed shadow
    border: "none",      // Ensures no border
    p: 3,
    borderRadius: "8px",
    backgroundColor: "white",
    minHeight: "450px",
  }}
>

  {/* Contact Details Heading */}
  <Typography
    variant="h3"
    fontWeight="bold"
    sx={{
      fontSize: { xs: "2rem", md: "2.5rem" },
      fontFamily: "Teko",
      color: "#5D0A0B",
      lineHeight: "1", // Removes extra spacing below text
      paddingBottom: "5px", // Adjusts spacing precisely
    }}
  >
    Contact Details
  </Typography>

  {/* Underline (Directly Under Heading) */}
  <Box
    sx={{
      width: "100%",
      maxWidth: "300px",
      height: "4px",
      backgroundColor: "#5D0A0B",
      mx: "auto",
      marginTop: "10px", // Prevents extra gap
    }}
  />

<TableContainer
  component={Paper}
  sx={{
    mx: "auto",
    maxWidth: "400px",
    mt: 2,
    p: 2,
    minHeight: "350px", // Keeps the container height fixed
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  }}
>
  <Table sx={{ height: "100%" }} aria-label="contact table">
    <TableBody>
    <TableRow sx={{ height: "33.33%" }}> {/* Distributes height evenly */}
<TableCell sx={{ py: 3, display: "flex", alignItems: "flex-start" }}> {/* Aligns content properly */}
  <LocationOnIcon sx={{ color: "red", pt: 1 }} />
  <Typography
    sx={{
      fontSize: "17px",
      fontFamily: "Roboto",
      ml: 1, // Ensures spacing between icon and text
      display: "block", // Makes text behave as block
    }}
  >
    6818 Ellerslie Road SW, Edmonton, Alberta, TX6 1A3
  </Typography>
</TableCell>
</TableRow>
      <TableRow sx={{ height: "33.33%" }}>
        <TableCell sx={{ py: 3 }}>
          <MailIcon sx={{ color: "skyblue", pt: 1 }} />
          <Typography sx={{ fontSize: "17px", fontFamily: "Roboto", display: "inline", ml: 1 }}>
          info@kadakcafe.ca
          </Typography>
        </TableCell>
      </TableRow>
      <TableRow sx={{ height: "33.33%" }}>
        <TableCell sx={{ py: 3 }}>
          <CallIcon sx={{ color: "green", pt: 1 }} />
          <Typography sx={{ fontSize: "17px", fontFamily: "Roboto", display: "inline", ml: 1 }}>
            +1 403 923 8621
          </Typography>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</TableContainer>


</Box>


{/* Right Side: Our Location */}
<Box
  sx={{
    flex: { xs: 1, md: 2 }, // Increases width dynamically (more space on larger screens)
    width: "100%", // Ensures full width on smaller screens
    maxWidth: { xs: "100%", sm: "600px", md: "850px", lg: "1000px" }, // Adjusts max width for different screens
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "none", // Removed shadow
    border: "none", // Ensures no border
    p: 3,
    borderRadius: "8px",
    backgroundColor: "white",
    minHeight: "450px", // Keeps height equal to Contact Details box
  }}
>


  <Typography
    variant="h3"
    fontWeight="bold"
    sx={{
      fontSize: { xs: "2rem", md: "2.5rem" },
      mb: 1,
      fontFamily: "Teko",
      color: "#5D0A0B",
    }}
  >
    Our Location
  </Typography>
  <Box
    sx={{
      width: "100%",
      maxWidth: "300px",
      height: "4px",
      backgroundColor: "#5D0A0B",
      mx: "auto",
      mb: 2,
    }}
  />
  <iframe
    title="Google Map"
    style={{
      height: "350px",
      width: "100%",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
      flexGrow: 1,
    }}
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2822.019362098566!2d-113.55979818490746!3d53.42262817880054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53716ebf003f19d9%3A0x9f2417a6f8d20450!2s6818%20Ellerslie%20Rd%20SW%2C%20Edmonton%2C%20AB%20T6X%201A3%2C%20Canada!5e0!3m2!1sen!2sin!4v1707930412289!5m2!1sen!2sin"    allowFullScreen=""
    loading="lazy"
  ></iframe>
</Box>

</Box>
<Footer />

    </>
  
  );
};











const hexagonTextStyle = {
  fontSize: "clamp(14px, 2vw, 20px)", // 🔹 Increased font size
  fontWeight: "bold",
  textAlign: "center",
  lineHeight: "0.9", // 🔹 Slightly increased line height for better readability
  marginBottom: "1vw", // 🔹 More spacing below the title
  whiteSpace: "normal", // Allows text to wrap
  wordBreak: "break-word", // Prevents long words from breaking layout
  maxWidth: "100%", // Prevents overflowing
  fontFamily: "Teko",
};


const hexagonContentStyle = {
  fontSize: "clamp(10px, 1.5vw, 16px)", // Content font slightly bigger
  textAlign: "center",
  lineHeight: "1.2",
  fontFamily:"Roboto",
};


const buttonStyle = {
  width: "400px", 
  padding: "15px 30px",
  fontSize: "18px",
  fontFamily: "Teko",
  backgroundColor: "gold",
  color: "#fff",
  cursor: "pointer",
  transition: "all 0.3s ease",
  border: "none",
  borderRadius: "8px",
  position: "relative",
  fontWeight:"bold",

  /** 🎯 Strong 3D Perspective **/
  transform: "perspective(1000px) rotateX(15deg) translateZ(15px)",

  /** ✅ Depth & Shadows **/
  boxShadow: `
    0px 12px 25px rgba(0, 0, 0, 0.6),  /* Outer shadow */
    inset 0px 10px 20px rgba(255, 255, 255, 0.15), /* Soft top light */
    inset 0px -10px 30px rgba(0, 0, 0, 0.7), /* Bottom shadow */
    inset 10px 0px 20px rgba(0, 0, 0, 0.5), /* Left shadow */
    inset -10px 0px 20px rgba(255, 255, 255, 0.2) /* Right highlight */
  `,

  /** ✅ 3D Borders (No Top Border) **/
  borderBottom: "6px solid rgba(0, 0, 0, 0.7)",
  borderLeft: "6px solid rgba(0, 0, 0, 0.5)",
  borderRight: "6px solid rgba(255, 255, 255, 0.2)",
  borderBottomLeftRadius: "10px",
  borderBottomRightRadius: "10px",
};


// **Perfect Hexagon with Equal Sides**
const hexagonStyle1 = {
 
    width: "250px",
    height: "220px",
   // background: "linear-gradient(to bottom, #1E6F91, #0D4F67)", 
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "20px",
    clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
    fontSize: "16px",
    position: "relative",
    
    /** 🎯 Strong 3D Perspective **/
    transform: "perspective(1000px) rotateX(15deg) translateZ(15px)",
  
    /** ✅ 6-Sided Depth & Shadows **/
    boxShadow: `
      0px 12px 25px rgba(0, 0, 0, 0.6),  /* Outer shadow */
      inset 0px 10px 20px rgba(255, 255, 255, 0.15), /* Soft top light */
      inset 0px -10px 30px rgba(0, 0, 0, 0.7), /* Bottom shadow */
      inset 10px 0px 20px rgba(0, 0, 0, 0.5), /* Left shadow */
      inset -10px 0px 20px rgba(255, 255, 255, 0.2), /* Right highlight */
  
      /** 🌟 Side Shadows for Full 3D Depth **/
      inset 15px 15px 20px rgba(0, 0, 0, 0.6), /* Bottom-left */
      inset -15px -15px 20px rgba(255, 255, 255, 0.2) /* Top-right */
    `,
  
    /** ✅ 3D Borders (No Top Border) **/
    borderBottom: "6px solid rgba(0, 0, 0, 0.7)",  
    borderLeft: "6px solid rgba(0, 0, 0, 0.5)",  
    borderRight: "6px solid rgba(255, 255, 255, 0.2)",  
    borderBottomLeftRadius: "10px",  
    borderBottomRightRadius: "10px",  
  };
  
  



// **Smooth Infinite Scrolling**
const scrollStyles = `
@keyframes scrollBoxes {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); } /* Moves only half to allow infinite loop */
}`;

document.styleSheets[0].insertRule(scrollStyles, document.styleSheets[0].cssRules.length);


export default Contact;